import React, { useState } from "react";
import styles from "./CheckboxFilterButton.module.scss";
import { OrangeCheckBox, WhiteCheckBox } from "../../../../../../assets/icons";

type Props = {
	label: string
	filter: string
	value: string
	onCheck: (value: boolean) => void
};

const CheckboxFilterButton: React.FC<Props> = (props: Props) => {

	const [ isChecked, setIsChecked ] = useState(false);

	const onButtonClick = () => {
		setIsChecked(prev => !prev)
		props.onCheck(!isChecked);
	}
	return (
		<div className={styles.filterDropdownItem} onClick={onButtonClick}>
			{ isChecked ? <OrangeCheckBox width={20} height={20}/> : <WhiteCheckBox width={20} height={20}/>}
			{props.label}
		</div>
	);
};

export default CheckboxFilterButton;
